import { render, staticRenderFns } from "./MissingTransactions.vue?vue&type=template&id=135a53ea&"
import script from "./MissingTransactions.vue?vue&type=script&lang=js&"
export * from "./MissingTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports